import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate } from 'react-router-dom';
import { useMount } from 'react-use';
const RatingNotification = (props) => {
    const navigate = useNavigate();
    useMount(() => {
        window.setTimeout(() => {
            props.notificationRemoveById({ id: props.notification.id });
        }, props.notification.startTime);
    });
    const handleClick = (e) => {
        e.stopPropagation();
        if (props.notification.mainAction &&
            typeof props.notification.mainAction === 'function') {
            const action = props.notification.mainAction();
            if (action !== undefined) {
                nextAndExecute(action);
            }
        }
        else if (props.notification.mainAction &&
            typeof props.notification.mainAction === 'object' &&
            props.notification.mainAction.navigate) {
            navigate(props.notification.mainAction.navigate);
        }
        else {
            e.preventDefault();
            return;
        }
    };
    const nextAndExecute = (action) => {
        const next = action.next();
        if (next.value) {
            const nextCopy = Object.assign({}, next);
            props.dispatch(nextCopy.value.PUT.action);
            nextAndExecute(action);
        }
    };
    return (_jsx("div", Object.assign({ className: `alert alert-rating ${props.notification.type === 'rating-up'
            ? 'alert-success'
            : 'alert-danger'}`, onClick: handleClick }, { children: _jsx("div", { children: _jsx("span", { className: props.notification.type === 'rating-down'
                    ? 'i-thumbs-down'
                    : 'i-thumbs-up' }) }) })));
};
export default RatingNotification;
